import React from 'react'
import styled from 'styled-components'

const ShowcaseColletion = styled.div`
    
    
`

const ShowcaseContent = styled.div`
    width:72%;
    margin:0 auto;
    display:grid;
    grid-template-rows:repeat(2,auto);
    align-items:center;
    justify-items:center;
    padding-top:120px;

    @media(max-width:640px){
        padding-top:96px;
        grid-template-columns:repeat(1,auto); 
        width:100%;
        grid-gap:0px;        
        
    }
 
`

const Imageview = styled.div`
   
`

const Cover = styled.img`
    width:320px;
    height:220px;
    border-radius:16px;
    
    @media(max-width:640px){
        border-radius:16px;  }
`
const CoverCaption = styled.p`
    font-size:12px;
    padding-left:8px;
    color:var(--GrayLevel3);
    border-left:2px solid var(--GrayLevel5);
    
`
const Description = styled.div`
    border-radius:24px;
    padding:0px 12px;  
   
`

const Title = styled.h2`
    color:var(--GrayLevel1);
`
const Subtitle = styled.h4`

    font-style:italic;
    color:var(--GrayLevel2);
`
const Subtitle02 = styled.h4`
    font-style:italic;
    color:var(--GrayLevel2);
`

const Text01 = styled.p`
    color:var(--GrayLevel3);
    font-size:14px;
    line-height:1.5;
`

const Text02 = styled.p`
    color:var(--GrayLevel3);
    font-size:16px;
    line-height:1.6;
    height:48px;
    overflow:hidden;
`
const Button = styled.button`
    padding:12px 20px;
    background:var(--NaviBlue);
    border:none;
    border-radius:12px;
    color:var(--WhitePatch1);
    font-size:16px;
    font-weight:bold;
    box-shadow:0px 12px 24px rgba(0,0,0,0.05);
    transition: 1s cubic-bezier(0.2,0.8,0.2,1);

    &:hover{
        transform:scale(1.05,1.05) 
    }
    
        `


const Bingo = props =>(
    <ShowcaseColletion>
        <ShowcaseContent>
            <div className="Imageview">
                <Cover src={props.image} />
                <CoverCaption>{props.text}</CoverCaption>
            </div>
            <Description>
                <Title>{props.title}</Title>
                <Subtitle>{props.subtitle}</Subtitle>
                <Text01>{props.text}</Text01>
                <Subtitle02>{props.subtitle02}</Subtitle02>
                <Text02>{props.text02}</Text02>
                <Button>{props.link}</Button>
            </Description>
        </ShowcaseContent>
        
    </ShowcaseColletion>

)

export default Bingo